import { ContentService } from "../services";

/**
 * A function that handles the like and dislike functionality.
 *
 * @param {Object} options - An object containing the following properties:
 *  - status {string} - The status of the like/dislike.
 *  - tenantId {string} - The ID of the tenant.
 *  - queryId {string} - The ID of the query.
 *  - feedback {string} - Optional. The feedback message.
 *  - isLikeHandler {boolean} - Optional. Indicates if it's a like handler.
 *
 * @returns {Promise} - A promise that resolves to the response of the update operation.
 */
const likeDisLikeHandler = async ({
  status,
  tenantId,
  queryId,
  feedback = "",
  isLikeHandler = false,
}) => {
  try {
    const requestObj = isLikeHandler
      ? { status, tenantId, queryId }
      : {
          status,
          tenantId,
          queryId,
          feedback: {
            message: feedback,
          },
        };

    const response = await new ContentService().updateLikeDislike(requestObj);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export default likeDisLikeHandler;
